import { useContext } from 'react';
import PropTypes from 'prop-types';
import { doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { uploadFileToAws, getFileUrl, listFilesInFolder } from '../minioConfig';

import { db } from '../firebaseConfig';
import { EnvironmentContext } from '../Context/EnvironmentContext';

// Function to duplicate a folder (including icons here)
async function duplicateFolder(sourceFolder, destinationFolder) {
    try {
        // Get the list of files in the source folder
        const fileList = await listFilesInFolder(sourceFolder);

        // Duplicate each file in the new folder
        if (fileList.Contents) {
            await Promise.all(fileList.Contents.map(async (item) => {
                const downloadURL = getFileUrl(item.Key);
                const response = await fetch(downloadURL);
                const blob = await response.blob();

                const destinationKey = `${destinationFolder}/${item.Key.split('/').pop()}`;
                await uploadFileToAws(destinationKey, blob);
            }));
        }

        console.log('Folder duplicated successfully!');
    } catch (error) {
        console.error('Error duplicating folder:', error);
    }
}

async function duplicateStory(storyId, newId, ownerId) {
    try {
        // Get the record to duplicate
        const storyRef = doc(db, 'stories', storyId);
        const storySnap = await getDoc(storyRef);

        if (storySnap.exists()) {
            // Create a new record with the new ID and retrieved data
            const newStoryRef = doc(db, 'stories', newId);
            await setDoc(
                newStoryRef, 
                { 
                    ...storySnap.data(), 
                    id: newId, 
                    creation_date: new Date(),
                    owner: ownerId,
                    parameters: {
                        ...storySnap.data().parameters,
                        access: 'limited',
                    },
                });

            await duplicateFolder(`contacts/icons/${storyId}`, `contacts/icons/${newId}`);

            console.log('Story duplicated successfully!');
            return newId;
        } else {
            console.log('The story to duplicate does not exist.');
            return null;
        }
    } catch (error) {
        console.error('Error duplicating story:', error);
        return null;
    }
}

export { duplicateStory };